/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/features/people/PeopleTab.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { PeoplePanel, ClaimsPanel } from "./Panels.js";
import { IdentityReview } from "./IdentityReview.js";
import { PeopleStats } from "./PeopleStats.js";
import { CorpusPeople } from "./CorpusPeople.js";
import { SectionHeading } from "../../components/shared/Display.js";
import { is_corpus_snapshot } from "../../components/shared/Scale.js";
import { __jacCallFunction } from "@jac/runtime";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
import { _jac } from "@jac/prelude";
async function search_people(incident_id, query, limit) {
  return await __jacCallFunction("search_people", {"incident_id": incident_id, "query": query, "limit": limit});
}
function PeopleTab(props) {
  const {snapshot, onRefresh, onShowOnMap: onShowOnMap = null, reviewRequest: reviewRequest = 0} = props;
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [reviewKey, setReviewKey] = useState("");
  const [results, setResults] = useState(null);
  const [searching, setSearching] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [searchedFor, setSearchedFor] = useState("");
  useEffect(() => {
    setResults(null);
    setQuery("");
    setSearchedFor("");
    setSearchError("");
    setSelectedId("");
    setReviewKey("");
  }, [snapshot.incident_id]);
  useEffect(() => {
    if (((reviewRequest <= 0) || (snapshot.duplicates.length === 0))) {
      return;
    }
    let pending = snapshot.duplicates.filter(d => (d.decision === "PENDING")).map(d => d);
    let first = ((pending.length > 0) ? pending[0] : snapshot.duplicates[0]);
    setQuery("");
    setReviewKey(((first.person_a_id + "|") + first.person_b_id));
  }, [reviewRequest]);
  async function runSearch() {
    let term = query.trim();
    if ((term === "")) {
      setResults(null);
      setSearchedFor("");
      return;
    }
    setSearching(true);
    setSearchError("");
    try {
      setResults(await __jacCallFunction("search_people", {"incident_id": snapshot.incident_id, "query": term, "limit": 100}));
      setSearchedFor(term);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSearchError(("Search failed: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setSearching(false);
  }
  let raw = snapshot;
  let corpus = is_corpus_snapshot(raw);
  if (corpus) {
    return __jacJsx(CorpusPeople, {"snapshot": snapshot, "people": ((results != null) ? results : snapshot.people), "query": query, "searching": searching, "searchError": searchError, "searchedFor": searchedFor, "selectedId": selectedId, "onSelect": pid => {
      setSelectedId(pid);
    }, "onQuery": value => {
      setQuery(value);
      if ((value.trim() === "")) {
        setResults(null);
        setSearchedFor("");
      }
    }, "onSearch": runSearch, "onShowOnMap": onShowOnMap}, []);
  }
  let q = query.trim().toLowerCase();
  let people = snapshot.people.filter(p => ((q === "") || p.name.toLowerCase().includes(q))).map(p => p);
  let selected = null;
  for (const p of people) {
    if ((p.id === selectedId)) {
      selected = p;
    }
  }
  if (((selected == null) && (people.length > 0))) {
    selected = people[0];
  }
  let duplicates = snapshot.duplicates.filter(d => (((q === "") || d.person_a.toLowerCase().includes(q)) || d.person_b.toLowerCase().includes(q))).map(d => d);
  let matches = snapshot.duplicates.filter(d => ((reviewKey !== "") && (((d.person_a_id + "|") + d.person_b_id) === reviewKey))).map(d => d);
  let personA = null;
  let personB = null;
  let reviewPanel = null;
  if ((matches.length > 0)) {
    let review = matches[0];
    for (const p of snapshot.people) {
      if ((p.id === review.person_a_id)) {
        personA = p;
      }
      if ((p.id === review.person_b_id)) {
        personB = p;
      }
    }
    reviewPanel = __jacJsx(IdentityReview, {"candidate": review, "personA": personA, "personB": personB, "onRefresh": onRefresh, "onClose": () => {
      setReviewKey("");
    }}, []);
  }
  return __jacJsx("div", {"className": "flex flex-col gap-5"}, [__jacJsx(SectionHeading, {"title": "People", "subtitle": "Find someone, see every report about them, and check possible matches."}, []), __jacJsx(PeopleStats, {"people": snapshot.people, "duplicates": snapshot.duplicates}, []), __jacJsx("label", {"className": "flex max-w-xl flex-col gap-2 text-sm"}, [__jacJsx("span", {"className": "font-medium"}, ["Search people"]), __jacJsx("input", {"type": "search", "value": query, "onChange": e => {
    setQuery(e.target.value);
  }, "placeholder": "Type a name, for example Maya", "className": "h-11 w-full rounded-md border border-input bg-card px-3 text-base outline-none focus-visible:ring-2 focus-visible:ring-ring"}, []), __jacJsx("span", {"className": "text-xs text-muted-foreground"}, [(((String(people.length) + " of ") + String(snapshot.people.length)) + " people shown")])]), __jacJsx("div", {"id": "identity-review", "className": "scroll-mt-4"}, [reviewPanel]), __jacJsx("div", {"className": "grid items-start gap-8 xl:grid-cols-2"}, [__jacJsx(PeoplePanel, {"people": people, "duplicates": duplicates, "selectedId": (selected ? selected.id : ""), "onSelect": pid => {
    setSelectedId(pid);
  }, "onReview": key => {
    setReviewKey(key);
  }}, []), __jacJsx(ClaimsPanel, {"person": selected, "incidentId": snapshot.incident_id, "onShowOnMap": onShowOnMap, "mappedClaimIds": snapshot.locations.flatMap(place => place.evidence.map(e => e.claim_id))}, [])])]);
}
/*jac:refresh-boundary*/;
export {PeopleTab};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:search_people": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=PeopleTab.js.map
